export default "__VITE_ASSET__BlhNeDj4__"